import { Text } from '@fluentui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    buildContextualDetailGroups,
    CONTEXTUAL_DETAILS_TITLE,
} from 'app/modules/newTicketView/contextualDetails';
import { ViewerRole } from 'app/modules/newTicketView/types';
import './NewTicketViewCards.scss';

interface IProps {
    /** The request being rendered (generated `RequestDto` or a list item). */
    selectedRequest?: unknown;
    /** Gates the Warranty contact/shipping PII; viewers never see it. */
    viewerRole?: ViewerRole;
    isVisible?: boolean;
}

/**
 * The single "Contextual Details" card on the Request Details surfaces. Its body
 * swaps on the request type and each field is hidden when empty; the card is not
 * rendered at all for request types with no contextual variant.
 */
const ContextualDetailsCard = ({
    selectedRequest,
    viewerRole = ViewerRole.Viewer,
    isVisible = true
}: IProps) => {
    const { t: translate } = useTranslation();
    const groups = buildContextualDetailGroups(selectedRequest, viewerRole);

    if (!isVisible || groups.length === 0) {
        return null;
    }

    return (
        <div className="contextual-details-card" data-testid="contextual-details-card">
            <div className="cd-card-title">
                <Text>{translate(CONTEXTUAL_DETAILS_TITLE)}</Text>
            </div>
            {groups.map((group) => (
                <div className="cd-group" key={group.key} data-testid={`contextual-group-${group.key}`}>
                    {group.label && (
                        <div className="cd-group-label">
                            <Text>{translate(group.label)}</Text>
                        </div>
                    )}
                    <div className="cd-fields">
                        {group.fields.map((detail) => (
                            <div
                                className="cd-field"
                                key={detail.key}
                                data-testid={`contextual-field-${detail.key}`}>
                                <div className="cd-field-label">
                                    <Text>{translate(detail.label)}</Text>
                                </div>
                                <div className="cd-field-value">
                                    <Text>{detail.value}</Text>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ContextualDetailsCard;
